/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc メッセージ送信フォーム
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-send-message-form">

  <el-main class="main-area">
    <el-form ref="fastchatSendMessageForm" :model="fastchatSendMessage" :rules="rules">
      <el-form-item prop="messageText">
        <el-autocomplete ref="suggestAutocomplete" class="inline-input" style="width:100%; visibility: hidden; position: absolute;" popper-class="fhsuggest-popper" :fetch-suggestions="suggestFetchFunc" @select="suggestAutocompleteSelectHandler"></el-autocomplete>
        <el-input ref="sendMessageTextArea" class="send-message-textarea" type="textarea" resize="none" @keyup.enter.ctrl.native="send" :readonly="!permissionSendMessageInput" :autosize="{ minRows: 3, maxRows: 8}" :placeholder="$t('こちらに質問内容を入力してください')"
          v-model="fastchatSendMessage.messageText"></el-input>
      </el-form-item>
    </el-form>
  </el-main>

  <el-aside class="send-message-button-wrapper" width="auto">
    <el-button class="send-message-button" type="primary" :disabled="!permissionSend" @click="send">{{$t('送信')}}</el-button>
  </el-aside>

</el-container>
</template>

<script>
import {
  Autocomplete,
  Input,
  Button,
  Container,
  Aside,
  Main,
  Form,
  FormItem
} from 'element-ui'
import ValidateUtil from '@/utils/ValidateUtil'

export default {
  name: 'FcSendMessageForm',
  components: {
    'el-autocomplete': Autocomplete,
    'el-input': Input,
    'el-button': Button,
    'el-container': Container,
    'el-aside': Aside,
    'el-main': Main,
    'el-form': Form,
    'el-form-item': FormItem
  },
  props: ['disabled', 'requesting', 'receptionMode', 'useSuggestion'],
  data() {
    return {
      fastchatSendMessage: {
        messageText: ''
      },
      rules: {
        messageText: [{
          max: this.$root.$config.sendMessageMaxLength,
          message: this.$t('{sendMessageMaxLength} 文字以内にしてください', {
            sendMessageMaxLength: this.$root.$config.sendMessageMaxLength
          }),
          trigger: 'change'
        }, {
          validator: this.validateWrongPatternList,
          trigger: 'change'
        }]
      },
      validFastchatSendMessageForm: false,
      suggestList_: [],
      determiningSuggestTargetKeyword: false
    }
  },
  watch: {
    'fastchatSendMessage.messageText'(newVal) {
      if (newVal != null && newVal.length !== 0) {
        this.$emit('messageTyping', null)
      }
      if (!this.determiningSuggestTargetKeyword) {
        this.determiningSuggestTargetKeyword = true
        setTimeout(_ => {
          this.determiningSuggestTargetKeyword = false
          if (this.permissionSuggestion) {
            this.$emit('suggestion', this.fastchatSendMessage.messageText.trim())
          } else if (this.$refs['suggestAutocomplete'].suggestionVisible) {
            this.$refs['suggestAutocomplete'].close()
          }
        }, this.$root.$config.suggestIntarval)
      }
    }
  },
  mounted() {
    setTimeout(_ => {
      this.validateFastchatSendMessageForm((valid) => {
        this.validFastchatSendMessageForm = valid
      })
      this.$refs['sendMessageTextArea'].resizeTextarea()
    }, 100)
  },
  updated() {
    this.validateFastchatSendMessageForm((valid) => {
      this.validFastchatSendMessageForm = valid
    })
  },
  computed: {
    /**
     * 送信メッセージの入力が可能か
     * @return {Boolean}
     */
    permissionSendMessageInput() {
      return !this.disabled && !this.requesting
    },
    /**
     * 送信可能か
     * @return {Boolean}
     */
    permissionSend() {
      return this.permissionSendMessageInput && this.fastchatSendMessage.messageText.length > 0 && this.validFastchatSendMessageForm
    },
    /**
     * サジェストが可能か
     * @return {Boolean}
     */
    permissionSuggestion() {
      if (!this.$config['_testMode'] && (!this.useSuggestion || !this.permissionSend)) {
        return false
      }
      const suggestTarget = this.fastchatSendMessage.messageText
      if (suggestTarget.trim().length === 0 || suggestTarget.indexOf('\n') > -1 || suggestTarget.indexOf('\r') > -1) {
        return false
      }
      return true
    }
  },
  methods: {
    /**
     * メッセージ送信情報フォームの入力チェック
     * @param  {Function} callback [description]
     */
    validateFastchatSendMessageForm(callback) {
      if (this.$refs['fastchatSendMessageForm']) {
        this.$refs['fastchatSendMessageForm'].validate((valid) => {
          callback(valid)
        })
      }
    },
    /**
     * 送信処理
     */
    send() {
      if (!this.permissionSend) {
        return
      }
      this.$emit('sendMessage', {
        messageText: this.fastchatSendMessage.messageText.trim()
      })
    },
    /**
     * 送信メッセージ情報フォームをクリアする
     */
    clearSendMessageForm() {
      this.suggestList_ = []
      this.determiningSuggestTargetKeyword = false
      this.$refs['suggestAutocomplete'].close()
      this.$refs['fastchatSendMessageForm'].resetFields()
    },
    /**
     * 送信制限文字列が入力されているかチェック
     */
    validateWrongPatternList(rule, value, callback) {
      ValidateUtil.validateWrongPatternSettingList(rule, value, this.receptionMode, callback)
    },

    /**
     * サジェストリストを表示する
     * @param  {[Array]} suggestList
     */
    showSuggestList(suggestList) {
      if (!this.permissionSuggestion) {
        return
      }
      this.suggestList_ = suggestList.map(function (item) {
        return {
          value: item
        }
      })
      this.$refs['suggestAutocomplete'].handleFocus()
    },
    /**
     * サジェストフェッチ処理
     * @param  {[String]}   queryString
     * @param  {Function} cb
     */
    suggestFetchFunc(queryString, cb) {
      const suggestList_ = this.suggestList_
      this.suggestList_ = null
      cb(suggestList_)
      setTimeout(_ => {
        if (this.$refs['suggestAutocomplete'].popperElm != null) {
          this.$el.appendChild(this.$refs['suggestAutocomplete'].popperElm)
        }
      }, 0)
    },
    /**
     * サジェスト選択処理
     * @param  {[Object]} item
     */
    suggestAutocompleteSelectHandler(item) {
      if (!this.permissionSend) {
        return
      }
      this.$emit('sendMessage', {
        messageText: item.value
      })
    }

  }
}
</script>

<style scoped>
.fc-send-message-form {
  position: relative;
}

.main-area {
  padding: 10px;
}

.menu-area {
  display: flex;
  align-items: center;
}

.menu-button {
  padding: 12px
}

.send-message-button-wrapper {
  display: flex;
  align-items: center;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form-item.is-error {
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/FcSendMessageForm.vue